import { Pause } from "./icons.js";
import { InfoTip } from "./info-tip.js";
import "./paused-mark.css";

/**
 * "Paused", beside a paused report's name in the top bar, with the reason a
 * click away. Without it a paused report reads as one whose numbers stopped for
 * no reason — the confusion this exists to prevent (DESIGN.md, A paused report).
 */
export function PausedMark({ brandName }: { readonly brandName: string }) {
  return (
    <span className="paused-mark">
      <span className="badge badge-empty paused-mark-badge">
        <Pause className="paused-mark-icon" aria-hidden="true" />
        Paused
      </span>
      <InfoTip label="Paused">
        Crux is not asking AI engines about {brandName} for this report. Everything
        captured up to the pause is still here. Resume it in Settings.
      </InfoTip>
    </span>
  );
}
